import createSpacingComponent from './Spacing'

const Box = createSpacingComponent('layout')

export default Box
